import { useContext, useEffect } from 'react';
import useAvailableMessagingChannels from 'components/domain/template/useAvailableMessagingChannels';
import { MessagingChannel } from 'models/inbox/Messages';
import { isVrboOfflineLead } from 'utils/lead/leadUtils';
import InboxContext from '../../InboxContext';
import InboxMessagesContext from '../InboxMessagesContext';

// The Vrbo API can't deliver messages for offline bookings.
const OFFLINE_LEAD_PREFERRED_CHANNELS = [
  MessagingChannel.EMAIL,
  MessagingChannel.SMS,
];

const useInboxAvailableMessagingChannels = () => {
  const {
    activeThread,
    activeLead,
    threadAvailableMessagingChannelsMap,
    updateThreadAvailableMessagingChannelsMap,
  } = useContext(InboxContext);
  const { messages } = useContext(InboxMessagesContext);
  const { uid: activeThreadUid } = activeThread || {};

  const {
    defaultMessagingChannel: sharedDefaultMessagingChannel,
    channels,
    isLoadingMessagingChannels,
    fetchedAvailableMessagingChannels,
  } = useAvailableMessagingChannels({
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    threadUid: activeThreadUid,
    availableMessagingChannelsMap: threadAvailableMessagingChannelsMap,
    lead: activeLead,
    messages,
  });

  useEffect(() => {
    if (fetchedAvailableMessagingChannels) {
      updateThreadAvailableMessagingChannelsMap({
        // @ts-expect-error TS2464 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        [activeThreadUid]: fetchedAvailableMessagingChannels,
      });
    }
  }, [fetchedAvailableMessagingChannels]);

  const defaultMessagingChannel = isVrboOfflineLead(activeLead)
    ? OFFLINE_LEAD_PREFERRED_CHANNELS.find((channel) =>
        channels.includes(channel),
      ) ?? sharedDefaultMessagingChannel
    : sharedDefaultMessagingChannel;

  return { defaultMessagingChannel, channels, isLoadingMessagingChannels };
};

export default useInboxAvailableMessagingChannels;
